import React, {
  useState, Fragment, useEffect,
} from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { CountryCodes } from '@Apis/constants';
import {
  Checkbox,
  Select,
  Table,
} from 'antd';
import PropTypes from 'prop-types';
import {
  LoadingOutlined,
} from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import searchIcon from '@Images/icons/icon-search.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import RfqActions from '@Actions/purchase/rfq/rfqActions';
import './style.scss';
import SellerActions from '@Actions/sellerActions';
import PRZSelect from '../../../../../Common/UI/PRZSelect';

const { Option } = Select;
const RfqVendorSelector = ({
  user, participants, loading, updateRfqParticipant, getSellers, getSellersLoading, callback, sellers, sendRfqNotificationLoading, handleDelete, updateRfqParticipantLoading, selectedRfq, updateData, data, isEditing, setIsEditing, sendRfqNotification,
}) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [call, setCall] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [useAllProductForVendors, setUseAllProductForVendors] = useState(true);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [searchOnlyWhenEnter, setSearchOnlyWhenEnter] = useState('');
  const getColumns = () => {
    const columns = [
      {
        title: 'VENDOR',
        fixed: 'left',
        render: (record) => (
          <div>
            <Link to={`/vendors/view/${record?.seller_info?.seller_id}`} target="_blank">
              {`#${record?.seller_info?.internal_slr_code}`}
            </Link>
            <H3Text text={record?.seller_info?.seller_name} />
          </div>
        ),
      },
      {
        title: 'CONTACT NUMBER',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => (
          <div style={{ whiteSpace: 'nowrap', minWidth:'100px' }}>
            {record?.seller_info?.mobile_1 ? `${CountryCodes?.find((code) => code?.dial_code == record?.seller_info?.dial_code)?.flag} +${record?.seller_info?.dial_code} ${record?.seller_info?.mobile_1}` : '-'}
          </div>
        ),
      },
      {
        title: 'EMAIL',
        render: (record) => (
          <div style={{ minWidth:'100px' }}>
            {record?.seller_info?.email_id_1 || '-'}
          </div>
        ),
      },
      // {
      //   title: '',
      //   className: 'list__actions-column',
      //   width: '40px',
      //   fixed: 'right',
      //   render: (text, record) => (
      //     <H3Text
      //       text={(
      //         <div>
      //           {(sendRfqNotificationLoading)
      //             ? <LoadingOutlined /> : (
      //               <FontAwesomeIcon icon={faCirclePlus} />
      //             )}
      //           {' '}
      //           Add
      //         </div>
      //       )}
      //       onClick={() => {
      //         if (!selectedRows?.length) {
      //           const payload = [{
      //             action: 'ADD',
      //             rfq_id: selectedRfq?.rfq_id,
      //             seller_id: record?.seller_info?.seller_id,
      //             tenant_id: selectedRfq?.tenant_id,
      //             participant_name: record?.seller_info?.seller_name,
      //             dial_code: record?.seller_info?.dial_code,
      //             email: record?.seller_info?.email_id_1,
      //             phone_number: record?.seller_info?.mobile_1,
      //           },
      //           ];
      //           updateRfqParticipant(payload, () => {
      //             setCall(!call);
      //             callback();
      //             setSelectedRows([]);
      //             setSelectedRows([]);
      //           });
      //         }
      //       }}
      //       className={`invitees__table-action invitees__table-action-vendor ${selectedRows?.length ? 'invitees__table-action-disabled' : ''}`}
      //     />
      //   ),
      // },
    ];

    return columns;
  };

  useEffect(() => {
    getSellers('', user?.tenant_info?.tenant_id, page, limit, '', () => { }, true, null);
  }, [call]);

  useEffect(() => {
    const searchCustomer = setTimeout(() => {
      getSellers(
        searchKeyword,
        user?.tenant_info?.tenant_id,
        page,
        limit,
        null, null,
      );
    }, 500);
    return () => clearTimeout(searchCustomer);
  }, [searchOnlyWhenEnter, page]);

  const handleSubmit = (action) => {
    const payload = selectedRows?.map((item) => (
      {
        action,
        rfq_id: selectedRfq?.rfq_id,
        seller_id: item?.seller_info?.seller_id,
        tenant_id: selectedRfq?.tenant_id,
        participant_name: item?.seller_info?.seller_name,
        dial_code: item?.seller_info?.dial_code,
        email: item?.seller_info?.email_id_1,
        phone_number: item?.seller_info?.mobile_1,
        product_sku_ids: useAllProductForVendors ? selectedRfq?.rfq_lines?.map((product) => product.product_sku_id) : selectedProducts,
        rfq_line_ids: !useAllProductForVendors ? selectedRfq?.rfq_lines?.filter((product) => selectedProducts.includes(product.product_sku_id)).map((product) => product.rfq_line_id) : selectedRfq?.rfq_lines?.map((product) => product.rfq_line_id),
      }
    ));
    updateRfqParticipant(payload, () => {
      setCall(!call);
      callback();
      setSelectedRows([]);
      setSelectedRows([]);
    });
  };
  return (
    <Fragment>
      <div className="rfq-vendor-selector">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '5px',
          }}
        >
          <div
            className="section-search-bar__wrapper"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
            }}
          >
            <div className="section-search-bar">
              <input
                value={searchKeyword}
                placeholder="Search by vendor name.."
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setSearchKeyword(e.target.value);
                    setSearchOnlyWhenEnter(!searchOnlyWhenEnter)
                    setPage(1);
                  }
                }}
                onChange={(event) => {
                  setSearchKeyword(event.target.value);
                }}
              />
              <H3Image
                src={searchIcon}
                className="section-search-bar__icon"
                alt="search"
                onClick={() => {
                  setSearchKeyword(searchKeyword);
                  setSearchOnlyWhenEnter(!searchOnlyWhenEnter)
                  setPage(1);
                }}
              />
            </div>
            <div className="product_selector_rfq_wrapper">
              {!useAllProductForVendors && (
                <PRZSelect
                  mode="multiple"
                  placeholder="Select product"
                  maxTagCount="responsive"
                  value={selectedProducts}
                  onChange={(value) => {
                    setSelectedProducts(value);
                  }}
                  className="product_selector_rfq"
                >
                  {selectedRfq?.rfq_lines?.map((product) => (
                    <Option key={product.product_sku_id} value={product.product_sku_id}>
                      <Fragment>
                        <H3Text
                          text={`#${product?.product_sku_info?.internal_sku_code || ''} ${product?.product_sku_info?.product_sku_name}`}
                          className="product-filter__option-text"
                        />
                      </Fragment>
                    </Option>
                  ))}
                </PRZSelect>
              )}
            </div>
          </div>
          <Checkbox
            onChange={(e) => {
              setUseAllProductForVendors(e.target.checked);
            }}
            checked={useAllProductForVendors}
          >
            <H3Text text="Invite selected vendors for all products" />
          </Checkbox>
        </div>
        <Table
          bordered
          title={() => (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <H3Text
                text={`${sellers && sellers.count ? sellers.count : '0'
                  } Total Vendor(s)`}
                className=""
              />
            </div>
          )}
          loading={loading || getSellersLoading}
          showHeader
          size="small"
          columns={getColumns()}
          dataSource={sellers?.sellers?.filter((i) => !(participants?.map((j) => j?.seller_id)?.includes(i?.seller_info?.seller_id)))?.map((item, index) => ({
            key: item?.tenant_seller_id,
            ...item,
          })) || []}
          pagination={sellers?.count >= 100 ? {
            defaultCurrent: 1,
            total: sellers?.count,
            pageSize: 100,
            position: ['bottomLeft'],
            showSizeChanger: false,
            onChange: (pg, pageSize) => {
              setPage(pg);
              setLimit(pageSize);
              setCall(!call);
            },
          } : false}
          scroll={{ x: 'max-content', y: 'calc(100dvh - 160px)' }}
          rowSelection={{
            onChange: (rowKeys, rows) => {
              setSelectedRowKeys(rowKeys);
              setSelectedRows(rows);
            },
            selectedRowKeys,
          }}
        />
        {selectedRows?.length > 0 && (
          <div className="custom-drawer__footer">
            <H3Button
              text={`Add ${selectedRows?.length} Participants`}
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              onClick={() => handleSubmit('ADD')}
              isLoading={loading || updateRfqParticipantLoading}
              disabled={loading || updateRfqParticipantLoading}
            />
          </div>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, RfqReducers, SellerReducers,
}) => ({
  user: UserReducers.user,
  createRfqLoading: RfqReducers.createRfqLoading,
  updateRfqLoading: RfqReducers.updateRfqLoading,
  getRfqByIdLoading: RfqReducers.getRfqByIdLoading,
  updateRfqParticipantLoading: RfqReducers.updateRfqParticipantLoading,
  sendRfqNotificationLoading: RfqReducers.sendRfqNotificationLoading,
  getSellersLoading: SellerReducers.getSellersLoading,
  sellers: SellerReducers.sellers,
});

const mapDispatchToProps = (dispatch) => ({
  updateRfqParticipant: (payload, callback) => dispatch(RfqActions.updateRfqParticipant(payload, callback)),
  sendRfqNotification: (payload, callback) => dispatch(RfqActions.sendRfqNotification(payload, callback)),
  getSellers: (keyword, tenantId, page, limit, sellerId, callback, isActive, isSubcontractor, sellerType) => dispatch(
    SellerActions.getSellers(keyword, tenantId, page, limit, sellerId, callback, isActive, isSubcontractor, sellerType),
  ),
});

RfqVendorSelector.propTypes = {
  user: PropTypes.any,
  sellers: PropTypes.any,
  participants: PropTypes.any,
  data: PropTypes.any,
  selectedRfq: PropTypes.any,
  loading: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RfqVendorSelector));
